import React, { Component } from 'react'
import { colors, mq, animations } from 'src/styles'
import styled from '@emotion/styled'
import Slider from 'react-slick'
import { GatsbyImage } from 'gatsby-plugin-image'

const ProductSliderWrap = styled.div`
	position: relative;
	${ ({ fullHeight }) => fullHeight ? `
		height: 100%;
	` : `
	` }
`

const ProductSlideshow = styled(Slider)`
	position: relative;
	z-index: 1;
	${ ({ fullHeight }) => fullHeight ? `
		height: 100%;
		.slick-slide,
		.slick-track,
		.slick-list {
			height: 100% !important;
			min-height: 100%;
			img {
				height: 100%;
				width: 100%;
			}
		}
		.slick-slide > div,
		.gatsby-image-wrapper {
			height: 100%;
		}
		.gatsby-image-wrapper > div:first-of-type {
			padding-top: 70vh !important;
			min-height: 100vw;
		}
		${ mq.largerAndUp } {
			.gatsby-image-wrapper > div:first-of-type {
				padding-top: 0 !important;
				min-height: 0;
			}
		}
	` : `
		padding-bottom: 30px;
	` }
`

const ProductImg = styled(GatsbyImage)`
	${ ({ fullHeight }) => fullHeight ? `
		img {
			object-fit: cover !important;
		}
	` : `
		img {
			object-fit: contain !important;
		}
	` }
`

const Arrow = styled.button`
	width: 50%;
	height: 100%;
	position: absolute;
	top: 0;
	z-index: 2;
	appearance: none;
	border: none;
	padding: 0;
	outline: none;
	background: transparent;
	${ mq.mediumAndBelow } {
		display: none !important;
	}
	${ ({ direction }) => direction === 'next' ? `
		cursor: -webkit-image-set(url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAZCAYAAAHS9pe3AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAALaADAAQAAAABAAAAGQAAAAAxwTksAAADqklEQVRYCc1XS0wTQRj+Z7alBUQK5WGMjxhiBDVB0IOPbanxRYwajZrYXRBf6YGbEuPBSw8mXrxoTDRqCFHAg0GjCVFBo4BHuwUM4iNGowkCBhBKhJZlx3+atGnA1VIodi478z++/ebf+f/5F2BORqfTkR8d0Au326Br6XGKTFc5TaFI9nPThHqCqdBhEl6nbb8GsBsIKyBATIxBu0DoXWtuTgoHQ/1ZYmQP9YDDckUSv4QXcz5hjJGoQd87HVmhTxL0Uk7sWEz84xVMg40Y4Vwg8JMQaASTuaG4urmHI0+NkO7bcKN9uspIRdfJXZmR6/mZeyTbk7+9Kfow6qAwl8uo+N4GFtK09JV1j0cizWYNHgLzHnNYNL86BEBurr/b5uJy0lXpWOD/Sa0gaNmMqVlUwzlhKYywUcrABwbj58IVJd3E7cYjPX3wQ/T2VGmGwEwTqekmtb/vezlanV9f/2r5dOsYJF5JPOyRxKsxuOq7IOA7fW0iahSn7WCH7FgSF25e2X5BkcWLcQHnyYOFoDVO4GK3Itk+RoLPWcJgzO8xYIcsaWZL3o1nw2Fgfujby0s2aZq2ljKSh3V0GTBmxXxKxTpoRP041sIfhNBuzJo3Bkq7DEmmntW3ngwRQoIX0rfTh5P7+3q/AoNO0lG+M2dSG8sCDbIppZlM06xAyQTTMAtB6COGpA+Fd5r6I7cZOf/k2p7O16NjVE2xCOrIgG9QAGFPpM2s5u1yyQH8kE9nBTLVWXGKvT2uvcE7caouprW3zL4Zj9r9mJz1nBTZXqXIttV6+pjk/AQxt5vG5BwvJ6Vsa6FXssvxwo8rrtcpVmIbMchP6kxfFE7smTrOlT1WmhqsNBVYHBoykoSyFTUvx/+F/d9Jc4LB9mFIfYElbQMSep1sNJUW3H4+oEc+IUiHyPEWFsbGmpD8Gizdw1QAuai2rTGkDz0TinSIFH/yZNUYuwTAFuEGeiklVUV1rfVcRzolMYMJtEibhGIsN8Uow13CKjxnJm4Q/SCTaPsDozCEl9sozgOIgXceXnEAFP9ueBlLwoUZ9WaMphkJLcB1KtehlYaXnIrmE7hWUR5AfQAB/MCIEedLUYaA5CI+E3Mox23Z4GfXkeU+3NCVFHOGO7/6kY+zTSjS3Ue3WX+pgcvYZGzBTuLMurqWB38K6X8nzVuWYZ//Gn55OxGE40W1Lc1/IpoQMmwxj/DLBf8bgr9NMyE175H2SHY3ptMGS5pJ5m3rTMiGbH8DRUVOtMcYjSIAAAAASUVORK5CYII=')
 1x, url('data:image/png;base64,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')
 2x) 35 15, auto;
		right: 0;
	` : `
		cursor: -webkit-image-set(url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAYCAYAAAH2aC8sAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAALKADAAQAAAABAAAAGAAAAACLB9vfAAADkElEQVRYCc1XTUwTURB+s9uWliL4gwTFgz8YCdGo4EnbptGDcjBeRNOWKGjE+HcyMfFg7MGDB43GxIsH8ReMJiRqPEg8GMQED23BiEbRcBCUIChIFWHb9/yWwHYXoSl2Td1LZ+bNfDNvOv12ythfPeJupZxaYMjv+j7VUyJGF6caNb3jsDdHU2YQKOR3PyRmPSoxpYQTrWZC7BNClBJjnwRji9U4yGOQPxowOoKVNoMhmSJqa63JzrWzkM/9WVOSCak2jiIBzxlc4T5jYiUXfCMT7Aja9gUXmg/bRPdpyGazlo8nDPlcOJvFE/a5u2bhbnRFtmajJQ0tFHCfiATcB9KAMIaG/a640ZK+Jk1APMbV36cPl0DAmCaeSLV3KR+NdTkd83NLrj4YTpyYKIX9nv0mwiWguqq99oQ2e2myx4bI9oB3yeAYP2gwpquAP25h5Dali6PFi2BQAugXzWCGgFGrwSyfNQNLw0CVdaGAZ7dmMEkglYHITgVsjC1kgvIlogWC8XwuqAj8vAG0tRm5HET0A/ogI3KCs+fq8xMxDtobgR3h7HxZfcspS0Hhouy+3s8/ZatUtu5Gs3nEo2ZGJgr7XBwUfkFfiWkygFvBtc9NA9QDtfm8LlO5WA+uyuEql2+qbTa6gd1SCVRf0L/e9jbmMLl6VcPT/lRiMuIT8bsqMTg9eHtVZaSAiaRJO9y2x7OeK+IOlqH3suyoWXuzqS+Txaq5/yj4pd+1XBHsGk5itixp75q6ZuPSluGKLWp+leDD755cArMdjDPhL29o8WS4rhnTUzjgOS44PweKHUC7O+CpboxxwUQcWyTHpohPoS5JMcHoOwn2lUgMcDbu30+SNCAxPgDPQdnhHCzdmjtEu+5Nu1SpL/2Y4rAN26JZzl+ysMyxKNERKWZZkaeUnr6rgO7/WExF0Gt51S0v4CPxZZKN99Cn2u3ZvcPfHsHTC95vzMux71tx5cnQjFec5kBl8va9WxZzRSnGxYtB7UUYqUXALMT3l4cQB5phh+6AbEUjoIqJpYPGED+KYn/irB8+fTj/AIw3siS/WHv7abc+pTbD6l+ESPT1bSFYJQJG0eFDGI06vfP/IGsF64uJ+N07MAvXx7tD1OS0z9v5z7ZOfeIU5GkLnoxT56etkweF4Cfxg2zNdszblunCkxY8Wbj62RmoyI3y6GUOuiuvf1ajP/vv5Zc+b0nnsYqsTBT6GwYSSWHSE1w6AAAAAElFTkSuQmCC')
 1x, url('data:image/png;base64,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')
 2x) 35 15, auto;
		left: 0;
	` }
`

const SlideshowDots = styled.ul`
	list-style: none;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	left: 0;
	right: 0;
	z-index: 9999;
	${ ({ fullHeight }) => fullHeight ? `
		bottom: 30px;
	` : `
		bottom: 0;
	` }
`

const SlideshowDot = styled.li`
	width: 10px;
	height: 10px;
	color: ${ colors.mainColor };
	cursor: pointer;
	border-radius: 50%;
	margin: 0 5px;
	border: 2px solid;
	transform: scale(.6);
	transition: transform ${ animations.mediumSpeed } ease-in-out, background ${ animations.mediumSpeed } ease-in-out;
	${ ({ fullHeight }) => fullHeight ? `
		color: ${ colors.white };
		border-color: white;
		background: white;
	` : `
		border-color: currentcolor;
		background: currentcolor;
	` }
	.slick-active & {
		transform: none;
		background: transparent;
	}
`

export default class ProductSlider extends Component {
	constructor (props) {
		super(props)
		this.state = {
			nav1: null,
			nav2: null
		}
	}

	componentDidMount () {
		this.setState({
			nav1: this.slider1,
			nav2: this.slider2
		})
	}

	render () {
		const { productImages, fullHeight } = this.props
		const sliderSettings = {
			dots: true,
			arrows: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			adaptiveHeight: true,
			nextArrow: <Arrow direction='next'/>,
			prevArrow: <Arrow direction='prev'/>,
			appendDots: dots => <SlideshowDots fullHeight={fullHeight}>{dots}</SlideshowDots>,
			customPaging: (slider, i) => (<SlideshowDot fullHeight={fullHeight} active={slider === i}>{i}{slider.current}</SlideshowDot>),
			responsive: [
				{
					breakpoint: 768,
					settings: {
						dots: true,
						arrows: false,
						appendDots: dots => <SlideshowDots fullHeight={fullHeight}>{dots}</SlideshowDots>,
			customPaging: (slider, i) => (<SlideshowDot fullHeight={fullHeight} active={slider === i}>{i}{slider.current}</SlideshowDot>),
					}
				}
			]
		}

		return (
			<ProductSliderWrap fullHeight={fullHeight}>
				<ProductSlideshow
					{...sliderSettings}
					fullHeight={fullHeight}
					asNavFor={this.state.nav2}
					ref={slider => (this.slider1 = slider)}
				>
					{productImages.map((image, index) => {
						return (
							<ProductImg
								fullHeight={fullHeight}
								key={'product-image-' + index}
								image={image?.image?.gatsbyImageData}
								alt={image.altText}
								seamless={image.altText && image.altText.includes('seamless')}
							/>
						)
					})}
				</ProductSlideshow>

			</ProductSliderWrap>
		)
	}
}
